<button (click)="close()" class="modal-close"></button>
<h4
  class="modal-title"
  i18n="FdmBlackBox|Title for changing company to BlackBox @@Are you sure?"
>
  Are you sure?
</h4>

<div class="modal-content">
  <p
    class="c-form__item"
    i18n="FdmBlackBox|Extra info about changing FDM blackBox settings @@You can only change your FDM settings once! Please verify if the following steps are done:"
  >
    You can only change your FDM settings once! Please verify if the following
    steps are done:
  </p>
  <ul class="c-form__item">
    <li
      *ngIf="data.type && data.type === 'blackbox restaurant'"
      i18n="FdmBlackBox|connected and VSC card is present @@Your blackbox is connected and your VSC card is present."
    >
      Your blackbox is connected and your VSC card is present.
    </li>
    <li *ngIf="data.type && data.type === 'blackbox restaurant v2'">
      The establishment unit number is filled in.
    </li>
    <li i18n="FdmBlackBox|Tabs are closed @@All open tables are closed.">
      All open tables are closed.
    </li>
    <li i18n="FdmBlackBox|price precision @@Price precision is set to 0.01.">
      Price precision is set to 0.01.
    </li>
    <li
      i18n="FdmBlackBox|VAT number is filled @@Your VAT number is filled in correctly (for example: BE0123456789)."
    >
      Your VAT number is filled in correctly (for example: BE0123456789).
    </li>
    <li
      i18n="FdmBlackBox|SSN number @@The social security number needs to be filled in for every user in the system."
    >
      The social security number needs to be filled in for every user in the
      system.
    </li>
    <li i18n="FdmBlackBox|Closing reports @@Closing Reports is disabled.">
      Closing Reports is disabled.
    </li>
    <li
      *ngIf="data.type && data.type === 'blackbox restaurant v2'"
      i18n="FdmBlackBox|Product quantity types @@Product quantity types are set correctly (default is 'piece'; update only if different). Can be changed only after FDM is enabled."
    >
      Product quantity types are set correctly (default is "piece"; update only
      if different). Can be changed only after FDM is enabled.
    </li>
    <li
      *ngIf="data.type && data.type === 'blackbox restaurant v2'"
      i18n="FdmBlackBox|Run a final z report @@Run a final z report."
    >
      Run a final z report.
    </li>
  </ul>
</div>

<div class="modal-footer">
  <button
    (click)="close()"
    class="o-button o-button--success"
    i18n="Button| Ok Button @@buttonOk"
  >
    OK
  </button>
</div>
